<div class="has-danger" *ngIf="formCtrl.invalid && formCtrl.dirty">
                    <div *ngFor="let errorDef of errorDefs">
                        <div *ngIf="getErrorDefinitionIsValid(errorDef)" class="form-control-feedback">
                            {{getErrorDefinitionMessage(errorDef)}}
                        </div>
                    </div>
               </div>


// WEBPACK FOOTER //
// ./src/shared/utils/validation-messages.component.ts.ValidationMessagesComponent.html